module.exports = {
  config: require('./config'),
  procedures:{
    call_log_create:{
      definition: require('./call_log_create/definition.json'),
      mock_data:require('./call_log_create/mock_data.json')
    },
        
    call_log_list:{
      definition: require('./call_log_list/definition.json'),
      mock_data:require('./call_log_list/mock_data.json')
    },
    call_log_read:{
      definition: require('./call_log_read/definition.json'),
      mock_data:require('./call_log_read/mock_data.json')
    },
    call_log_update:{
      definition: require('./call_log_update/definition.json'),
      mock_data:require('./call_log_update/mock_data.json')
    },
    provider_account_read:{
      definition: require('./provider_account_read/definition.json'),
      mock_data:require('./provider_account_read/mock_data.json')
    },
    provider_account_update:{
      definition: require('./provider_account_update/definition.json'),
      mock_data:require('./provider_account_update/mock_data.json')
    },
    sms_send:{
      definition: require('./sms_send/definition.json'),
      mock_data:require('./sms_send/mock_data.json')
    },
    campaign_phone_create:{
      definition: require('./campaign_phone_create/definition.json'),
      mock_data:require('./campaign_phone_create/mock_data.json')
    },
    campaign_phone_list:{
      definition: require('./campaign_phone_list/definition.json'),
      mock_data:require('./campaign_phone_list/mock_data.json')
    },
    campaign_phone_list:{
      definition: require('./campaign_phone_list/definition.json'),
      mock_data:require('./campaign_phone_list/mock_data.json')
    },
    campaign_phone_campaign_user_for_sms_list:{
      definition: require('./campaign_phone_campaign_user_for_sms_list/definition.json'),
      mock_data:require('./campaign_phone_campaign_user_for_sms_list/mock_data.json')
    },
    campaign_phone_campaign_user_list:{
      definition: require('./campaign_phone_campaign_user_list/definition.json'),
      mock_data:require('./campaign_phone_campaign_user_list/mock_data.json')
    },
    campaign_phone_campaign_user_create:{
      definition: require('./campaign_phone_campaign_user_create/definition.json'),
      mock_data:require('./campaign_phone_campaign_user_create/mock_data.json')
    },
    campaign_phone_campaign_user_delete:{
      definition: require('./campaign_phone_campaign_user_delete/definition.json'),
      mock_data:require('./campaign_phone_campaign_user_delete/mock_data.json')
    },
    campaign_phone_campaign_user_update:{
      definition: require('./campaign_phone_campaign_user_update/definition.json'),
      mock_data:require('./campaign_phone_campaign_user_update/mock_data.json')
    },
    sms_canned_message_create:{
      definition: require('./sms_canned_message_create/definition.json'),
      mock_data:require('./sms_canned_message_create/mock_data.json')
    },
    sms_canned_message_list:{
      definition: require('./sms_canned_message_list/definition.json'),
      mock_data:require('./sms_canned_message_list/mock_data.json')
    },
    sms_canned_message_update:{
      definition: require('./sms_canned_message_update/definition.json'),
      mock_data:require('./sms_canned_message_update/mock_data.json')
    },
    sms_conversation_read:{
      definition: require('./sms_conversation_read/definition.json'),
      mock_data:require('./sms_conversation_read/mock_data.json')
    },
    sms_conversation_list:{
      definition: require('./sms_conversation_list/definition.json'),
      mock_data:require('./sms_conversation_list/mock_data.json')
    },
    sms_conversation_create:{
      definition: require('./sms_conversation_create/definition.json'),
      mock_data:require('./sms_conversation_create/mock_data.json')
    },
    sms_conversation_update:{
      definition: require('./sms_conversation_update/definition.json'),
      mock_data:require('./sms_conversation_update/mock_data.json')
    },
    sms_conversation_message_list:{
      definition: require('./sms_conversation_message_list/definition.json'),
      mock_data:require('./sms_conversation_message_list/mock_data.json')
    },
    sms_conversation_message_create:{
      definition: require('./sms_conversation_message_create/definition.json'),
      mock_data:require('./sms_conversation_message_create/mock_data.json')
    },
    sms_conversation_message_delete:{
      definition: require('./sms_conversation_message_delete/definition.json'),
      mock_data:require('./sms_conversation_message_delete/mock_data.json')
    },
    sms_conversation_status_list:{
      definition: require('./sms_conversation_status_list/definition.json'),
      mock_data:require('./sms_conversation_status_list/mock_data.json')
    },
    sms_conversation_status_create:{
      definition: require('./sms_conversation_status_create/definition.json'),
      mock_data:require('./sms_conversation_status_create/mock_data.json')
    },
    sms_message_status:{
      definition: require('./sms_message_status/definition.json'),
      mock_data:require('./sms_message_status/mock_data.json')
    },
    sms_template_create:{
      definition: require('./sms_template_create/definition.json'),
      mock_data:require('./sms_template_create/mock_data.json')
    },
    sms_template_list:{
      definition: require('./sms_template_list/definition.json'),
      mock_data:require('./sms_template_list/mock_data.json')
    },
    sms_template_update:{
      definition: require('./sms_template_update/definition.json'),
      mock_data:require('./sms_template_update/mock_data.json')
    },
    sms_template_read:{
      definition: require('./sms_template_read/definition.json'),
      mock_data:require('./sms_template_read/mock_data.json')
    },
    sms_conversation_message_status_log_create:{
      definition: require('./sms_conversation_message_status_log_create/definition.json'),
      mock_data:require('./sms_conversation_message_status_log_create/mock_data.json')
    },
    email_send:{
      definition: require('./email_send/definition.json'),
      mock_data:require('./email_send/mock_data.json')
    },
    sms_queue_create:{
      definition: require('./sms_queue_create/definition.json'),
      mock_data:require('./sms_queue_create/mock_data.json')
    },
    sms_queue_list:{
      definition: require('./sms_queue_list/definition.json'),
      mock_data:require('./sms_queue_list/mock_data.json')
    },
    sms_queue_log_create:{
      definition: require('./sms_queue_log_create/definition.json'),
      mock_data:require('./sms_queue_log_create/mock_data.json')
    },
    sms_queue_log_list:{
      definition: require('./sms_queue_log_list/definition.json'),
      mock_data:require('./sms_queue_log_list/mock_data.json')
    },
    sms_queue_update:{
      definition: require('./sms_queue_update/definition.json'),
      mock_data:require('./sms_queue_update/mock_data.json')
    },
    socket_broadcast:{
      definition: require('./socket_broadcast/definition.json'),
      mock_data:require('./socket_broadcast/mock_data.json')
    },

    email_template_list:{
      definition: require('./email_template_list/definition.json'),
      mock_data:require('./email_template_list/mock_data.json')
    },

    email_template_create:{
      definition: require('./email_template_create/definition.json'),
      mock_data:require('./email_template_create/mock_data.json')
    },

    email_template_read:{
      definition: require('./email_template_read/definition.json'),
      mock_data:require('./email_template_read/mock_data.json')
    },

    email_template_update:{
      definition: require('./email_template_update/definition.json'),
      mock_data:require('./email_template_update/mock_data.json')
    },
    campaign_phone_read:{
      definition: require('./campaign_phone_read/definition.json'),
      mock_data:require('./campaign_phone_read/mock_data.json')
    }
  }
};